module.exports = __webpack_public_path__ + "images/sider-bar-download-app-com.52bcdf26.png";